import { useMemo } from 'react';

// Welcome Components
import { useWelcomeState } from './useWelcomeState';

// Utils
import { SocialLoginRecoveryOptions } from '../../../../utilities/social-login';
import { useGoogleLoginHandler, useSocialLoginHandlers } from '../../../../utilities/hooks';
import { useRegisterComponent } from '../../../orchestrator';
import { WELCOME_PAGE_ID } from '../constants';

export const useWelcomePageActions = () => {
  useRegisterComponent(useWelcomePageActions.name);

  const { state } = useWelcomeState();
  const { auth0Config, csrfToken, email, recoveryToken, redirectType } = state || {};

  const recoveryOptions: SocialLoginRecoveryOptions | undefined = useMemo(() => {
    return recoveryToken && email ? { expectedEmail: email, recoveryToken } : undefined;
  }, [email, recoveryToken]);

  const handleGoogleLogin = useGoogleLoginHandler({
    pageId: WELCOME_PAGE_ID,
    redirectType,
    redirectParams: {
      location: window.location,
      source: WELCOME_PAGE_ID,
      recoveryOptions,
    },
  });

  const { handleAppleLogin, handleMicrosoftLogin, handleSlackLogin } = useSocialLoginHandlers({
    pageId: WELCOME_PAGE_ID,
    redirectType,
    redirectParams: {
      location: window.location,
      auth0Config,
      csrfToken: csrfToken!,
      source: WELCOME_PAGE_ID,
      email,
      recoveryOptions,
    },
  });

  return {
    handleAppleLogin,
    handleMicrosoftLogin,
    handleSlackLogin,
    handleGoogleLogin,
  };
};
